module.exports = __webpack_public_path__ + "static/media/landing_02.c3cadfe4.svg";